import { render } from "./IconCopyStroke.vue?vue&type=template&id=7d21c808"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconCopyStroke.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d21c808"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d21c808', __exports__)) {
    api.reload('7d21c808', __exports__)
  }
  
  module.hot.accept("./IconCopyStroke.vue?vue&type=template&id=7d21c808", () => {
    api.rerender('7d21c808', render)
  })

}


export default __exports__